<div class="god-multi-user-select">
  <div class="fields-container">
    <!-- Primera fila: Selector de segmentación y autocomplete de estudiantes -->
    <div class="row">
      <div [class]="segmentationControl?.value === 'SPECIFIC_STUDENTS' ? 'col-6' : 'col-12'">
        <enfaf-select-light
          [options]="segmentationTypeOptions"
          [control]="segmentationControl"
          [placeholder]="'Selecciona el tipo de segmentación'"
          [label]="'¿Quién puede ver la promoción?'"
          class="segmentation-select"
        >
        </enfaf-select-light>
      </div>
      @if (segmentationControl?.value === promotionSegmentationType.SPECIFIC_STUDENTS) {
        <div class="col-6">
          <enfaf-multi-autocomplete-light #multiAutocomplete [label]="'Selecciona los alumnos'" [placeholder]="'Buscar'" [fetchData]="fetchStudents">
          </enfaf-multi-autocomplete-light>
        </div>
      }
    </div>

    <!-- Segunda fila: Autocompletes de cursos cuando está seleccionado COURSE_ENROLLMENT -->
    @if (segmentationControl?.value === promotionSegmentationType.COURSE_ENROLLMENT) {
      <div class="course-enrollment-container">
        <div class="course-enrollment-row">
          <!-- Columna 1: Alumnos matriculados -->
          <div class="course-column">
            <div class="course-section">
              <div class="course-section-title">Alumnos matriculados en:</div>
              <enfaf-multi-autocomplete-light
                #enrolledCoursesAutocomplete
                [label]="'Selecciona los cursos'"
                [placeholder]="'Buscar'"
                [fetchData]="fetchCourses"
                [disableOptions]="selectedNotEnrolledCourses"
                [hiddenBoxErrors]="true"
              >
              </enfaf-multi-autocomplete-light>

              <!-- Lista de cursos matriculados seleccionados -->
              @if (selectedEnrolledCourses.length > 0) {
                <div class="selected-courses-list">
                  @for (course of selectedEnrolledCourses; track course) {
                    <div class="course-item">
                      <span class="course-name">{{ course.title }}</span>
                      <app-enfaf-icon
                        [svgIconName]="'trash-red'"
                        [iconSize]="'16px'"
                        [iconStyle]="{ color: '#E03131' }"
                        [isButton]="true"
                        (onClick)="removeCourse(course, 'enrolled')"
                        class="remove-icon"
                      >
                      </app-enfaf-icon>
                    </div>
                  }
                </div>
              }
            </div>
          </div>

          <!-- Separador vertical -->
          <div class="vertical-separator"></div>

          <!-- Columna 2: Alumnos NO matriculados -->
          <div class="course-column">
            <div class="course-section">
              <div class="course-section-title">Alumnos NO matriculados en:</div>
              <enfaf-multi-autocomplete-light
                #notEnrolledCoursesAutocomplete
                [label]="'Selecciona los cursos'"
                [placeholder]="'Buscar'"
                [fetchData]="fetchCourses"
                [disableOptions]="selectedEnrolledCourses"
                [hiddenBoxErrors]="true"
              >
              </enfaf-multi-autocomplete-light>

              <!-- Lista de cursos NO matriculados seleccionados -->
              @if (selectedNotEnrolledCourses.length > 0) {
                <div class="selected-courses-list">
                  @for (course of selectedNotEnrolledCourses; track course) {
                    <div class="course-item">
                      <span class="course-name">{{ course.title }}</span>
                      <app-enfaf-icon
                        [svgIconName]="'trash-red'"
                        [iconSize]="'16px'"
                        [iconStyle]="{ color: '#E03131' }"
                        [isButton]="true"
                        (onClick)="removeCourse(course, 'notEnrolled')"
                        class="remove-icon"
                      >
                      </app-enfaf-icon>
                    </div>
                  }
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    }

    <!-- Lista de estudiantes seleccionados -->
    @if (segmentationControl?.value === promotionSegmentationType.SPECIFIC_STUDENTS && selectedStudents.length > 0) {
      <div class="selected-students-container">
        <div class="selected-students-title">Alumnos seleccionados:</div>
        <div class="selected-students-list">
          @for (student of selectedStudents; track student) {
            <div class="student-row">
              <div class="student-content">
                <div class="student-info">
                  <div class="student-name">{{ student.title }}</div>
                  <div class="student-email">{{ student.subtitle }}</div>
                </div>
              </div>
              <div class="student-actions">
                <app-enfaf-icon
                  [svgIconName]="'trash-red'"
                  [iconSize]="'21px'"
                  [iconStyle]="{ color: '#E03131' }"
                  [isButton]="true"
                  (onClick)="removeStudent(student)"
                  class="remove-icon"
                >
                </app-enfaf-icon>
              </div>
            </div>
          }
        </div>
      </div>
    }
  </div>
</div>
